import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions } from './details-form-helpers';

/**
 * SECTION 3: CLIENT EMERGENCY CONTACT INFORMATION
 */
export function getClientSpeakOnBehalfsFields(options: DetailsFormOptions): FormlyFieldConfig[] {
	return [
		// Emergency Contacts
		{
			key: 'Speak_on_Behalf',
			type: 'repeat',
			props: {
				label: 'Speak on behalf',
				addText: 'Add Speak on Behalf',
				addIcon: 'person_add',
				emptyMessage: 'No speak on behalf added yet',
			},
			fieldArray: {
				fieldGroupClassName: 'row panel-small',
				fieldGroup: [
					{
						className: 'col-12 col-sm-6 col-md-3',
						key: 'Applicant_Type',
						type: 'select',
						props: {
							label: 'Applicant Type',
							required: true,
							options: toFormlyOptions(options.applicantTypes$),
						},
					},
					{
						className: 'col-12 col-sm-6 col-md-3',
						key: 'Full_Name',
						type: 'input',
						props: {
							label: 'Full Name',
							required: true,
						},
					},
					{
						className: 'col-12 col-sm-6 col-md-3',
						key: 'Relation_to_Applicant',
						type: 'input',
						props: {
							label: 'Relation to Applicant',
							required: true,
						},
					},
					{
						className: 'col-12 col-sm-6 col-md-3',
						key: 'Phone_Number',
						type: 'phone',
						props: {
							label: 'Phone Number',
						},
					},
				],
			},
		},
	];
}